module.exports = __webpack_public_path__ + "static/limited-time-sale-f6ab61b1ecec790baf5a81ce411cba15.png";